import { useRef } from 'react';
import { Input } from '../ui/input';
import { Image, X, Loader2 } from 'lucide-react';

const HeroEditor = ({ data, setData, uploadImage, uploading }) => {
  const fileRef = useRef(null);
  const d = data;
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">العنوان الرئيسي</label>
        <Input value={d.title || ''} onChange={e => setData({ ...d, title: e.target.value })} placeholder="مبادرة غصن الزيتون القرائية" data-testid="hero-title" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">العنوان الفرعي</label>
        <Input value={d.subtitle || ''} onChange={e => setData({ ...d, subtitle: e.target.value })} placeholder="مبادرة عُمانية لتشجيع القراءة..." data-testid="hero-subtitle" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">الوصف</label>
        <textarea value={d.description || ''} onChange={e => setData({ ...d, description: e.target.value })} placeholder="وصف مختصر عن المبادرة..."
          className="w-full border rounded-xl p-3 min-h-[100px] resize-none text-sm focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none" data-testid="hero-desc" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-2">صورة الخلفية</label>
        {d.bg_image ? (
          <div className="relative rounded-xl overflow-hidden border">
            <img src={d.bg_image} alt="" className="w-full h-48 object-cover" />
            <button onClick={() => setData({ ...d, bg_image: '' })} className="absolute top-2 left-2 bg-red-500 text-white p-1.5 rounded-full"><X className="w-4 h-4" /></button>
          </div>
        ) : (
          <div onClick={() => fileRef.current?.click()} className="border-2 border-dashed rounded-xl p-8 text-center cursor-pointer hover:border-primary/50 transition-colors">
            {uploading ? <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary" /> : <><Image className="w-8 h-8 mx-auto text-gray-400 mb-2" /><p className="text-sm text-gray-500">اضغط لرفع صورة الخلفية</p></>}
          </div>
        )}
        <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={e => uploadImage(e.target.files?.[0], url => { setData({ ...d, bg_image: url }); if(fileRef.current) fileRef.current.value=''; })} />
      </div>
    </div>
  );
};

export default HeroEditor;
